import Enums from "../../../enums/enums";
import shareHelper from "../../../helper/shareHelper";
import i18n from "../../../locales/i18n";
import * as api from "../../../service/ApiSevice";
import store from "../../baseController";
export const actions = {
  DoSendEmailVerification({ commit }, input) {
    commit("MutationsSendEmailVerificationLoadingStatus", Enums.LoadingStatusType.Loading);
    api.UserService.DoSendEmailVerification(input).then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        commit("MutationsSendEmailVerificationLoadingStatus", Enums.LoadingStatusType.Success);
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Email_Link_Send_Successfully"),
          typeMessage: Enums.TypeComponentNoti.success,
        });
      } else {
        let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
        store.dispatch("SetAlertMessage", {
          alertMessage: alertMessage,
          typeMessage: Enums.TypeComponentNoti.error,
        });
        if (
          res.data.exception.code ===
          Enums.PeakExceptionResponseCode.EmailVerificationCannotResendUserVerifiedEmailComplete
        ) {
          commit("MutationsSendEmailVerificationLoadingStatus", Enums.LoadingStatusType.Failed);
        } else {
          commit("MutationsSendEmailVerificationLoadingStatus", Enums.LoadingStatusType.None);
        }
      }
    });
  },
  DoResendEmailVerification({ commit }, input) {
    commit("MutationsSendEmailVerificationLoadingStatus", Enums.LoadingStatusType.Loading);
    api.UserService.DoResendEmailVerification(input).then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        commit("MutationsSendEmailVerificationLoadingStatus", Enums.LoadingStatusType.Success);
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Email_Link_Send_Successfully"),
          typeMessage: Enums.TypeComponentNoti.success,
        });
      } else {
        let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
        store.dispatch("SetAlertMessage", {
          alertMessage: alertMessage,
          typeMessage: Enums.TypeComponentNoti.error,
        });
        if (
          res.data.exception.code ===
          Enums.PeakExceptionResponseCode.EmailVerificationCannotResendUserVerifiedEmailComplete
        ) {
          commit("MutationsSendEmailVerificationLoadingStatus", Enums.LoadingStatusType.Failed);
        } else {
          commit("MutationsSendEmailVerificationLoadingStatus", Enums.LoadingStatusType.None);
        }
      }
    });
  },
  DoGetVerifyEmail({ commit }, input) {
    commit("MutationsGetVerifyEmailLoadingStatus", Enums.LoadingStatusType.Loading);
    api.UserService.DoGetVerifyEmail(input).then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        commit("MutationsGetVerifyEmail", res.data.data);
        commit("MutationsGetVerifyEmailLoadingStatus", Enums.LoadingStatusType.Success);
      } else {
        commit("MutationsGetVerifyEmailLoadingStatus", Enums.LoadingStatusType.Failed);
        let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
        store.dispatch("SetAlertMessage", {
          alertMessage: alertMessage,
          typeMessage: Enums.TypeComponentNoti.error,
        });
      }
    });
  },
};
